import { useEffect, useState } from "react";
import api from "../../lib/api";

export default function DevAudit() {
  const [logs, setLogs] = useState([]);
  useEffect(()=>{ api.get("/developer/audit").then(r=>setLogs(r.data)); }, []);
  return (
    <div className="space-y-6">
      <div><div className="overline mb-2">Trail</div><h1 className="font-display text-4xl text-white">Audit Log</h1></div>
      <div className="card-luxe p-6 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-[11px] uppercase tracking-luxe text-white/40">
            <tr className="border-b border-white/5"><th className="text-left py-2">Time</th><th className="text-left">Action</th><th className="text-left">Actor</th><th className="text-left">Target</th><th className="text-left">IP</th></tr>
          </thead>
          <tbody>
            {logs.map(l => (
              <tr key={l.id} className="border-b border-white/5">
                <td className="py-3 text-white/60">{new Date(l.created_at).toLocaleString()}</td>
                <td className="text-copper font-mono text-xs">{l.action}</td>
                <td className="text-white/80">{l.actor_email||"—"} <span className="text-white/30 text-xs">({l.actor_role||"—"})</span></td>
                <td className="text-white/60 text-xs">{l.target||"—"}</td>
                <td className="font-mono text-xs">{l.ip||"—"}</td>
              </tr>
            ))}
            {logs.length === 0 && <tr><td colSpan="5" className="py-6 text-center text-white/40">No activity yet</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
